import * as Effects from 'redux-saga/effects'
import {
  IToggleCreateReservation,
  IToggleUpdateReservation,
} from '../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { requestProvenances } from '../../actions/provenances/loadProvenances'
import { ReservationModalActions } from '../../reducers/bookingCalendar/actionNames'

function* loadProvenances(
  action: IToggleUpdateReservation | IToggleCreateReservation,
) {
  if (action.toggle) {
    yield Effects.put(requestProvenances(new Date(0)))
  }
}

export default function*() {
  yield Effects.takeLatest(
    ReservationModalActions.ToggleCreateReservationModalRedux,
    loadProvenances,
  )
  yield Effects.takeLatest(
    ReservationModalActions.ToggleUpdateReservationModalRedux,
    loadProvenances,
  )
}
